module.exports = __webpack_public_path__ + "img/tan-lih-tyng.ef4bed23.png";